<template>
  <div class="flex flex-column justify-center align-center mb-4">
    <div class="flex flex-column align-center">
    <strong class="display-1">{{ $t('balanceMethodMessage') }}</strong>
    <span class="subtitle-1">{{ $t('selectPaymentMethodMessage') }}</span>
    </div>
    <div class="d-flex flex-row justify-space-around align-center flex-wrap mt-6">
      <div
          v-for="(method, index) in paymentMethods"
          :key="`payment-method-${index}`"
          @click="() => method.action()"
          class="card mx-2">
          <v-icon x-large>{{ method.icon }}</v-icon>
          <p class="mt-9">{{  method.name }}</p>
      </div>
    </div>
    <cash-payment v-model="cashPaymentDialog" />
  </div>
</template>

<script>
// import { EventBus } from '@/eventBus'
import CashPayment from '@/components/Dialogs/AddBalance/components/cashPayment.vue'
export default {
  name: 'stageOtherMethods',
  components: {
    CashPayment
  },
  data () {
    return {
      cashPaymentDialog: false,
      paymentMethods: [
        // {
        //   name: 'Debit',
        //   icon: 'mdi-checkbook',
        //   action: () => console.log(this.$t('noDevelopMethods') /* EventBus.$emit('toast', 'error', this.$t('noDevelopMethods') */)
        // },
        {
          name: this.$t('cash'),
          icon: 'mdi-cash',
          action: () => { this.cashPaymentDialog = !this.cashPaymentDialog /* EventBus.$emit('toast', 'error', this.$t('noDevelopMethods') */ }
        }
        // {
        //   name: 'Crypto',
        //   icon: 'mdi-currency-btc',
        //   action: () => console.log(this.$t('noDevelopMethods') /* EventBus.$emit('toast', 'error', this.$t('noDevelopMethods') */)
        // }
      ]
    }
  },
  methods: {
    toCredit () {
      this.$emit('billing-stage-credit')
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  display: flex;
  flex-direction: column;
  place-items: center;
  width: 150px;
  height: 150px;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  color: #999;
  font-weight: bold;
  transition: transform 0.5s;
}

.card:hover {
  transform: scale(1.2);
  transition: transform 0.5s;
  * {
      color: #1D3150;
  }
}
</style>
